import { render, staticRenderFns } from "./SignupSelection.vue?vue&type=template&id=3b81e022&scoped=true&"
import script from "./SignupSelection.vue?vue&type=script&lang=js&"
export * from "./SignupSelection.vue?vue&type=script&lang=js&"
import style0 from "./SignupSelection.vue?vue&type=style&index=0&id=3b81e022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81e022",
  null
  
)

export default component.exports